var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "contacts-section-wrapper" }, [
    _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v(_vm._s(_vm.$t("message.contacts")))]),
    ]),
    _vm._v(" "),
    _vm.contacts.length
      ? _c(
          "div",
          { staticClass: "contacts-section" },
          _vm._l(_vm.contacts, function (contact) {
            return _c(
              "div",
              { key: contact.id, staticClass: "contact-row" },
              [
                _c("div", { staticClass: "contact-info" }, [
                  _c("div", { staticClass: "contact-name" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("account_circle"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(contact.Full_Name))]),
                  ]),
                  _vm._v(" "),
                  contact.Email
                    ? _c("div", { staticClass: "contact-email" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("email"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(contact.Email))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  contact.Phone || contact.Mobile
                    ? _c("div", { staticClass: "contact-phone" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("phone"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(contact.Phone || contact.Mobile)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "contact-footer" }, [
                    _c("div", { staticClass: "contact-owner" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("person"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$_.get(contact, "Owner.name", ""))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.$_.get(contact, "Account_Name.name")
                      ? _c("div", { staticClass: "contact-account" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("business"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$_.get(contact, "Account_Name.name", "")
                              )
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "contact-layout" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("category"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$_.get(contact, "Layout.name", "Default Layout")
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "contact-date" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("event"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.formatDate(contact.Created_Time))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("SupsisButton", {
                  staticClass: "view-contact-btn",
                  attrs: { icon: "open_in_new" },
                  on: {
                    click: function ($event) {
                      return _vm.gotoContactOnZoho(contact.id)
                    },
                  },
                }),
                _vm._v(" "),
                _c("a-divider"),
              ],
              1
            )
          }),
          0
        )
      : _vm.loading
      ? _c(
          "div",
          { staticClass: "loading-container" },
          [
            _c("span", [_vm._v(_vm._s(_vm.$t("message.loadingContacts")))]),
            _vm._v(" "),
            _c("BucketSpinner", { staticClass: "large-spinner" }),
          ],
          1
        )
      : _c("div", { staticClass: "empty-contacts-container" }, [
          _c("span", { staticClass: "material-icons empty-icon" }, [
            _vm._v("contacts"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "empty-text" }, [
            _vm._v(_vm._s(_vm.$t("message.noContactsFound"))),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }